import { useNotifications } from '../contexts/NotificationContext';
import { formatDate } from '../utils/dateHelpers';

export default function NotificationDropdown({ isOpen, onClose }) {
  const { notifications, markAsRead } = useNotifications();

  if (!isOpen) return null;

  return (
    <>
      <div style={styles.backdrop} onClick={onClose} />
      <div style={styles.dropdown}>
        <div style={styles.header}>
          <span style={styles.headerTitle}>Notifications</span>
        </div>
        <div style={styles.list}>
          {notifications.length === 0 ? (
            <div style={styles.empty}>No notifications</div>
          ) : (
            notifications.map((n) => (
              <div
                key={n._id}
                style={{
                  ...styles.item,
                  backgroundColor: n.read ? '#ffffff' : '#f8f6f1',
                }}
              >
                <div style={styles.message}>{n.message}</div>
                <div style={styles.itemFooter}>
                  <span style={styles.date}>{formatDate(n.createdAt)}</span>
                  {!n.read && (
                    <button
                      style={styles.markBtn}
                      onClick={() => markAsRead(n._id)}
                    >
                      Mark read
                    </button>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
}

const styles = {
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 899,
  },
  dropdown: {
    position: 'absolute',
    top: '100%',
    right: 0,
    marginTop: '8px',
    width: '360px',
    maxHeight: '420px',
    background: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
    zIndex: 900,
    overflow: 'hidden',
    animation: 'slideDown 0.2s ease',
  },
  header: {
    padding: '14px 16px',
    borderBottom: '1px solid #f0ece4',
  },
  headerTitle: {
    fontSize: '0.95rem',
    fontWeight: 600,
    color: '#2B362E',
  },
  list: {
    maxHeight: '360px',
    overflowY: 'auto',
  },
  empty: {
    padding: '32px 16px',
    textAlign: 'center',
    color: '#B2AB9C',
    fontSize: '0.9rem',
  },
  item: {
    padding: '12px 16px',
    borderBottom: '1px solid #f5f0e8',
  },
  message: {
    fontSize: '0.85rem',
    color: '#2B362E',
    lineHeight: 1.5,
  },
  itemFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '6px',
  },
  date: {
    fontSize: '0.75rem',
    color: '#B2AB9C',
  },
  markBtn: {
    background: 'none',
    border: 'none',
    fontSize: '0.75rem',
    color: '#6B8063',
    cursor: 'pointer',
    fontWeight: 500,
    padding: 0,
  },
};
